module.exports = __webpack_public_path__ + "img/report.606b742f.png";